import { render, staticRenderFns } from "./selected-module.vue?vue&type=template&id=2f31c6b3&scoped=true&"
import script from "./selected-module.vue?vue&type=script&lang=js&"
export * from "./selected-module.vue?vue&type=script&lang=js&"
import style0 from "./selected-module.vue?vue&type=style&index=0&id=2f31c6b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31c6b3",
  null
  
)

export default component.exports